import type { ISelectOption } from 'src/types/ISelectOption';

function splitCamelCase(word: string): string {
  return word.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
}

function capitalizeFirstLetter(word: string, isSmallTextForRest?: boolean) {
  return `${word.charAt(0).toUpperCase()}${isSmallTextForRest ? word.slice(1).toLowerCase() : word.slice(1)}`;
}

const improveLabel = (
  { label, value }: ISelectOption,
  mapper: Partial<Record<number | string, string>> | null = null
) => ({
  value,
  label: mapper?.[value] || capitalizeFirstLetter(splitCamelCase(label)),
});

type Enumeration<T extends number | string = string> = {
  [K in T]: string;
};

export function castToOption(
  enumeration: Enumeration,
  // biome-ignore lint/suspicious/noExplicitAny: false
  formatter: Record<keyof Enumeration, any> | null = null,
  keyPrefix?: string | null
): ISelectOption[] {
  const options = Object.entries(enumeration).map(([key, value]) => {
    return { value: `${keyPrefix ?? ''}${enumeration[key]}`, label: formatter ? formatter[value] : enumeration[key] };
  });

  return formatter ? options : options.map((option) => improveLabel(option));
}

export function castToOptionWithEmpty({
  enumeration,
  formatter = null,
  keyPrefix,
  emptyLabel = 'N/A',
}: {
  enumeration: Enumeration;
  // biome-ignore lint/suspicious/noExplicitAny: false
  formatter: Record<keyof Enumeration, any> | null;
  keyPrefix?: string | null;
  emptyLabel?: string;
}): ISelectOption<string | null>[] {
  return [
    {
      value: null,
      label: emptyLabel,
    },
    ...castToOption(enumeration, formatter, keyPrefix),
  ];
}
